export const BASE_EDIT_TRY = 'BASE_EDIT_TRY';
export const BASE_EDIT_OK = 'BASE_EDIT_OK';
export const BASE_EDIT_ERROR = 'BASE_EDIT_ERROR';